import { saveUserData } from '../firebase/firestore';
import React, { useState } from 'react';
import {
  createUserWithEmailAndPassword,
  updateProfile,
  signOut,
} from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { auth } from '../firebase/firebase';
import { getFirestore } from 'firebase/firestore';
import logo from '../assets/logo.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Register.css';

const db = getFirestore();

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [num1, setNum1] = useState(Math.floor(Math.random() * 10) + 1);
  const [num2, setNum2] = useState(Math.floor(Math.random() * 10) + 1);
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false); // 🔹 Loader state

  const navigate = useNavigate();

  const refreshCaptcha = () => {
    setNum1(Math.floor(Math.random() * 10) + 1);
    setNum2(Math.floor(Math.random() * 10) + 1);
    setCaptchaAnswer('');
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('❗ Name is required.');
      return;
    }

    if (parseInt(captchaAnswer) !== num1 + num2) {
      setError('❌ Incorrect CAPTCHA ');
      return;
    }
setIsRegistering(true); // 🔹 Show spinner
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      await updateProfile(auth.currentUser, {
        displayName: name,
      });

      await saveUserData(userCredential.user.uid, {
        name,
        email,
        subscribed: false,
      });

      await signOut(auth);

     toast.success('🎉 Registered successfully! Redirecting to login...', {
  className: 'toast-blue',
  position: 'top-center',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
  closeButton: ({ closeToast }) => (
    <span
      onClick={closeToast}
      style={{
        color: '#013364ff',
        fontSize: '18px',
        fontWeight: 'bold',
        cursor: 'pointer',
        padding: '0 8px'
      }}
    >
      ×
    </span>
  ),
});


      // Delay redirect to show the toast
       setTimeout(() => {
        navigate('/login', { state: { registered: true } });
      }, 2000);

      // Clear form
      setName('');
      setEmail('');
      setPassword('');
      setCaptchaAnswer('');
      refreshCaptcha();
    } catch (err) {
      if (err.code === 'auth/email-already-in-use') {
        setError(
          <>
            ❗ This email is already registered. <br />
            Forgot your password? <Link to="/forgot-password">Reset now.</Link>
          </>
        );
      } else if (err.code === 'auth/weak-password') {
        setError('❗ Password should be at least 6 characters.');
      } else if (err.code === 'auth/invalid-email') {
        setError('❗ Please enter a valid email address.');
      } else {
        setError('❗ ' + err.message);
      }
    }finally {
      setIsRegistering(false); // 🔹 Hide spinner
    }
  };

  return (
    <div className="container mt-5">
      

      <div className="text-center mb-4">
        <img
          src={logo}
          alt="Logo"
          style={{ height: '100px', marginBottom: '20px' }}
        />
        <h1 className="display-4 text-primary fw-bold">KASHMIR JOBS</h1>
     <p className="lead fw-bold text-dark">Create Your Account Now!</p>

      </div>

      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow">
            <div className="card-body">
              <h3 className="card-title text-center mb-4">Register</h3>

              {error && (
                <div className="alert alert-danger text-center" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleRegister}>
                <div className="mb-3">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label>Password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? '🙈' : '👁️'}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label>Solve to Register:</label>
                  <div className="captcha-group">
                    <input
                      type="text"
                      value={num1}
                      readOnly
                      className="captcha-box"
                    />
                    <span>+</span>
                    <input
                      type="text"
                      value={num2}
                      readOnly
                      className="captcha-box"
                    />
                    <span>=</span>
                    <input
                      type="number"
                      value={captchaAnswer}
                      onChange={(e) => setCaptchaAnswer(e.target.value)}
                      required
                      placeholder="?"
                      className="captcha-input"
                    />
                    <button
                      type="button"
                      className="refresh-btn"
                      onClick={refreshCaptcha}
                      title="Refresh CAPTCHA"
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>

               <div className="d-grid">
  <button
    className="btn btn-primary"
    type="submit"
    disabled={isRegistering} // prevent double click
  >
    {isRegistering ? (
      <div className="spinner"></div> // loader
    ) : (
      'Register'
    )}
  </button>
</div>

              </form>

              <div className="text-center mt-3 already-account-text">
  <span>Already have an account?</span> <Link to="/login">Login here</Link>
</div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
